import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Unibrow from 'components/Unibrow';
import TypeIcon from 'components/TypeIcon';

import { unibrow as UnibrowPropType } from 'lib/CustomPropTypes';

const TeaseCategory = ({
  defaultSpacing,
  iconUrl,
  size,
  style,
  type,
  target,
  unibrow,
  vertical,
  deepLink,
}) => {
  const isPaidHub = vertical === 'sponsoredcontent';

  return (
    <Unibrow
      className={classNames(
        'tease-category__eyebrow',
        { [`tease-category__eyebrow--${size}`]: size },
        'f2 lh-none founders-mono fw1 ttu',
        style,
        {
          'pt4 pb1 ph5 pl4-m': defaultSpacing,
          pr8: ['video', 'slideshow'].includes(type),
          'bg-knockout-primary color-primary': isPaidHub,
        },
      )}
      unibrow={unibrow}
      vertical={vertical}
      target={target}
      deepLink={deepLink}
    >
      <TypeIcon
        type={type}
        url={iconUrl}
        target={target}
        className="tease-category__typeIcon"
      />
    </Unibrow>
  );
};

TeaseCategory.propTypes = {
  type: PropTypes.string.isRequired,
  unibrow: UnibrowPropType.isRequired,
  defaultSpacing: PropTypes.bool,
  iconUrl: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string,
  target: PropTypes.string,
  vertical: PropTypes.string,
  deepLink: PropTypes.objectOf(PropTypes.any),
};

TeaseCategory.defaultProps = {
  defaultSpacing: true,
  iconUrl: '',
  size: 'small',
  style: '',
  target: null,
  vertical: '',
  deepLink: null,
};

export default TeaseCategory;
